export var rst_resources = {
    AgentId:"Agente",
    DeviceName:"Nome Device",
    FileName:"Nome File",
    RstTagList:"Lista Tag",
    RstFolderID:"Scheda",
    CompanyName:"Società",
    Name:"Nome",
    Surname:"Cognome",
    AgentToken:"Token",
    Agent_DeviceName:"Nome Device",
    Agent_IsEnabled:"Agente abilitato",
    LastRunningDate:"Ultima esecuzione",
    Agent_IsRunning:"Agente attivo",
    DeviceArchitectureFamily:"Architettura",
    Agent_CompanyName:"Cliente",
    CurrentAgentVersion:"Versione agente",
    JobName:"Nome Job",
    CurrentStatusText:"Status attuale",
    CategoryNameText:"Categoria Job",
    FirstExecutionDate:"Data Inizio",
    EndExecutionDate:"Data Fine",
    NextRunTriggerDate:"Data Prossima",
    LastRunExitCode:"Ultimo codice",
    LastRunDateTime:"Ultima Data",
    IsJobEnabled:"Job abilitato",
    CurrentStatus:"Status",
    CategoryName:"Categoria",
    Created:"Creato",
    Modified:"Modificato",
    JobRunningLog:"Job Running Log",
    JobChartLog:"Job Chart Log",
    JobScheduler:"Job Scheduler",
    JobScheduler_IsJobEnabled:"Job abilitato",
    agentNew:"Nuovo",
    agent:"Agente",
    agentConfigReset:"Reset Agent Config",
    agentInstantSendHardwareLogs:"Invio Istantaneo Hardware Logs",
    agentSendCliCommand:"Esecuzione Comando CLI (SignalR)",
    TriggerType:"Modalità trigger",
    h_TriggerType:"Modalità con la quale si esegue il Job:<br/> <b>OneTime:</b> una volta all'orario indicato<br/><b>Minutely5:</b> ogni 5 minuti a partire dall'orario indicato<br/><b>Hourly:</b> ogni giorno a partire dall'orario indicato",
    CliCommand:"Comando da eseguire",
    h_CliCommand:"Nome del comando da eseguire (senza argomenti) p.e. <br/>apt<br/>ls<br/>mkdir",
    CliArgs:"Argomenti del comando",
    h_CliArgs:"Specificare un argomento per linea, gli spazi non sono considerati come separatori di argomento!",
    h_Job_FileName:"Nome del file da eseguire sull'agente, il file viene preso dalla cartella dell'agente, qui basta indicare il nome del file.",
    LastRunResultErr:"Ultimo messaggio di errore",
    StandErr:"Messaggio di errore",
    LastRunResultOut:"Ultimo messaggio",
    CustomerId:"Cliente",
    Subject:"Oggetto",
    Description:"Descrizione dell'elemento",
    Description_Help:"Descrizione",
    TicketHelpDescription:"Inserire la descrizione dettagliata del ticket, per far capire a <b>tutti</b> i collaboratori la problematica.",
    Priority:"Priorità",
    PriorityText:"Priorità",
    PriorityTextHelp:"Indicare la priorità del ticket quando è alta si viene avvisati con un alert",
    Patch_RebootRequired:"Riavvio Necessario",
    Patch_Classification:"Classificazione",
    Patch_ScheduleTime:"Ora di Installazione",
    Patch_PatchName:"Nome Patch",
    Patch_OsType:"Piattaforma OS",
    Patch_VersionToInstall:"Versione da Installare",
    Patch_VersionInstalled:"Versione Installata",
    Patch_Size:"Dimensione",
    Patch_DeviceName:"Nome Dispositivo",
    Patch_WorkflowHistory:"Storico Workflow",
    Patch_Description:"Descrizione",
    Software_IsEnabled:"Software Abilitato",
    Porta:"Porta",
    ProtocolTypeText:"Tipo protocollo",
    CompareTypeText:"Tipo comparazione",
    RequestHeaders:"Header per la request",
    RequestHeaders_Help:"Valori key/value per l'header request da inserire come json p.e. <br/> {'key': 'mykey', 'value': 'myvalue' }",
    RequestBody:"Body per la request",
    RequestBody_Help:"Testo o json da inviare nel Body della request. <br/> application/x-www-form-urlencoded: field1=value1&amp;field2=value2 <br/> application/json: { my json... } <br/> raw text: my free text",
    SendMessage:"Messaggio da inviare",
    HttpContentType:"Tipo di invio dati http",
    SendBodyAsJson:"Invia come JSON",
    SendBodyAsJson_Help:"Se vistato i dati vengono inviati come JSON (application/json) altrimenti vengono inviati come standard POST (application/x-www-form-urlencoded)",
    UpHttpStatusCodes:"HTTP status code validi",
    UpHttpStatusCodes_Help:"Viene creato un alert quando si riceve un HTTP status code diverso da quelli inseriti (pe.e 200,302 oppure 2xx, 3xx)",
    FilterMatchMonitorStatus:"Cambia status se filtro corrisponde",
    FilterMatchMonitorStatus_Help:"Se i criteri dei filtri corrispondono viene impostato lo stato attuale di monitoring",
    CurrentMonitorStatus:"Stato attuale di monitoring",
    CurrentMonitorStatus_Help:"Stato di monitoring del protocollo (Offline, Degraded, Operational, Maintenance)",
    FilterMatchCreateAlert:"Quando i filtri corrsispondono crea alert",
    FilterMatchCreateAlert_Help:"Se i filtri impostati sopra corrispondono (ritornano una condizione vera) viene creato un alert coi dati sottostanti",
    FilterMatchStrategy:"Condizione di corrispondenza dei filtri",
    FilterMatchStrategy_Help:"Si seleziona se devono corrispondere tutti i filtri, o se basta che ne corrisponda almeno uno",
    AlertName:"Nome alert",
    AlertSeverity:"Gravità alert",
    AutoResolveAlert:"Risolvi automaticamente alert",
    AutoResolveAlert_Help:"Se i filtri non corrispondo più l'alert viene risolto automaticamente",
    ProtocolName:"Nome",
    ProtocolType:"Tipo di protocollo",
    Url:"Url",
    Address:"Indirizzo",
    Address_Help:"Inserire l'indirizzo a dipendenza del servizio, url (http:\u002F\u002Fmy.site.com), ip (8.8.8.8), host (my.host.net), server",
    MonitorInterval:"Intervallo di monitoraggio",
    MonitorInterval_Help:"Intervallo di monitoraggio in <b>secondi</b> (si consiglia di usare almeno 60 secondi)",
    RequestTimeout:"Timeout per la richiesta",
    RequestTimeout_Help:"Tempo di timeout in <b>secondi</b> per la richiesta. Più è breve il timeout prima il servizio verrà segnalato come down",
    SlowResponseTimeAlert:"Tempo alert per la risposta",
    SlowResponseTimeAlert_Help:"Crea un alert se il tempo di risposta è superiore a quello impostato (in <b>millisecondi</b>). Quando ritorna ad un valore inferiore, si riceve una notifica e l'alert viene chiuso.",
    MaintenanceWindows:"Finestra di manutenzione",
    MaintenanceWindows_Help:"Finestre di manutenzione all'interno delle quali non si esegue alcun controllo. p.e. 14:00:30-15:55:45, 21:00-23:00",
    HttpVerb:"Http Verb",
    HttpVerb_Help:"Metodo da usare per fare la chiamata http (HEAD, GET, POST, PUT, PATCH, DELETE, OPTIONS, TRACE)",
    CompareType:"Modalità comparazione risultato Body",
    CompareType_Help:"Modalità con la quale comparare il contenuto del Body della risposta col campo <b>Risultato con successo</b>",
    SuccessResult:"Risultato con successo",
    SuccessResult_Help:"Testo usato per la comparazione col contenuto del Body usando la <b>Modalità comparazione risultato Body</b>",
    rstaDetails:"Dettagli",
    rstaNoElementSelectedSubTitle:"Nessun elemento selezionato",
    editToolbarItem:"Modifica",
    newToolbarItem:"Nuovo",
    deleteToolbarItem:"Elimina",
    deleteConfirmMessage:"Siete sicuri di voler eliminare l'elemento? L'operazione è irreversibile",
    rstuiUsername:"Nome utente",
    rstuiForgotPassword:"Password dimenticata?",
    rstuiWrongPasswordMsg:"Nome utente o password errati!",
    rstuiCancel:"Annulla",
    rstuiAll:"Tutti",
    rstuiFilters:"Filtri Standard",
    rstuiSchede:"Schede",
    rstuiSearch:"Ricerca",
    rstuiList:"Lista",
    rstuiTable:"Tabella",
    rstuiValidatorRequiredField:"Campo richiesto",
    rstuiValidatorMinValue:"Valore più basso del valore minimo",
    rstuiValidatorMaxValue:"Valore più alto del valore massimo"
    };
    export class RstLanguage {public static rst_resources_en = {
    AgentId:"Agent",
    DeviceName:"Device Name",
    FileName:"File Name",
    RstTagList:"Tag List",
    RstFolderID:"Fact sheet",
    CompanyName:"Society",
    Name:"Name",
    Surname:"Surname",
    AgentToken:"Tokens",
    Agent_DeviceName:"Device Name",
    Agent_IsEnabled:"Agent enabled",
    LastRunningDate:"Last run",
    Agent_IsRunning:"Active agent",
    DeviceArchitectureFamily:"Architecture",
    Agent_CompanyName:"Customer",
    CurrentAgentVersion:"Agent Version",
    JobName:"Job Name",
    CurrentStatusText:"Current status",
    CategoryNameText:"Job Category",
    FirstExecutionDate:"Start Date",
    EndExecutionDate:"End Date",
    NextRunTriggerDate:"Next Date",
    LastRunExitCode:"Latest Code",
    LastRunDateTime:"Last Date",
    IsJobEnabled:"Job enabled",
    CurrentStatus:"Status",
    CategoryName:"Category",
    Created:"Creation",
    Modified:"Altered",
    JobRunningLog:"Job Running Log",
    JobChartLog:"Job Chart Log",
    JobScheduler:"Job Scheduler",
    JobScheduler_IsJobEnabled:"Job enabled",
    agentNew:"New",
    agent:"Agent",
    agentConfigReset:"Reset Agent Config",
    agentInstantSendHardwareLogs:"Instant Hardware Logs",
    agentSendCliCommand:"Running CLI Command (SignalR)",
    TriggerType:"Trigger Mode",
    h_TriggerType:"How the Job is executed:<br/> <b>OneTime:</b> once at the indicated<br/> time<b>Minutely5:</b> every 5 minutes from the indicated<br/> time<b>Hourly:</b> every day from the indicated time",
    CliCommand:"Command to run",
    h_CliCommand:"Name of the command to be executed (without arguments) e.g. <br/><br/>apt ls<br/>mkdir",
    CliArgs:"Command arguments",
    h_CliArgs:"Specify one argument per line, spaces are not considered as argument separators!",
    h_Job_FileName:"Name of the file to be executed on the agent, the file is taken from the agent folder, here just indicate the name of the file.",
    LastRunResultErr:"Last error message",
    StandErr:"Error message",
    LastRunResultOut:"Last Post",
    CustomerId:"Customer",
    Subject:"Object",
    Description:"Item Description",
    Description_Help:"Description",
    TicketHelpDescription:"Enter the detailed description of the ticket, to make <b>all</b> collaborators understand the problem.",
    Priority:"Priority",
    PriorityText:"Priority",
    PriorityTextHelp:"Indicate the priority of the ticket when it is high you are notified with an alert",
    Patch_RebootRequired:"Restart required",
    Patch_Classification:"Classification",
    Patch_ScheduleTime:"Installation Time",
    Patch_PatchName:"Patch Name",
    Patch_OsType:"OS Platform",
    Patch_VersionToInstall:"Version to Install",
    Patch_VersionInstalled:"Installed Version",
    Patch_Size:"Dimension",
    Patch_DeviceName:"Device Name",
    Patch_WorkflowHistory:"Workflow History",
    Patch_Description:"Description",
    Software_IsEnabled:"Software Enabled",
    Porta:"Port",
    ProtocolTypeText:"Protocol Type",
    CompareTypeText:"Comparison Type",
    RequestHeaders:"Request header",
    RequestHeaders_Help:"Key value texts for the header for the request",
    RequestBody:"Body for the request",
    RequestBody_Help:"Text or json to be sent in the Body of the request. <br/> application/x-www-form-urlencoded: field1=value1&amp;field2=value2 <br/> application/json: { my json... } <br/> raw text: my free text",
    SendMessage:"Message to send",
    HttpContentType:"Type of http data submission",
    SendBodyAsJson:"Send the body as json (application/json) or as text (application/x-www-form-urlencoded)",
    SendBodyAsJson_Help:"Text or json to be sent in the Body of the request",
    UpHttpStatusCodes:"Valid HTTP status codes",
    UpHttpStatusCodes_Help:"An alert is created when an HTTP status code other than the following (200,302 or 2xx, 3xx) is received",
    FilterMatchMonitorStatus:"Change status if filter matches",
    FilterMatchMonitorStatus_Help:"If the filter criteria match, the current monitoring status is set",
    CurrentMonitorStatus:"Current monitoring status",
    CurrentMonitorStatus_Help:"Protocol monitoring status (Offline, Degraded, Operational, Maintenance)",
    FilterMatchCreateAlert:"When filters run it creates alerts",
    FilterMatchCreateAlert_Help:"If the filters set above match (return a true condition) an alert is created with the underlying data",
    FilterMatchStrategy:"Filter match condition",
    FilterMatchStrategy_Help:"You select whether all filters should match, or if it just needs to match at least one",
    AlertName:"Alert Name",
    AlertSeverity:"Alert severity",
    AutoResolveAlert:"Automatically resolve alerts",
    AutoResolveAlert_Help:"If the filters no longer match, the alert is automatically resolved",
    ProtocolName:"Name",
    ProtocolType:"Protocol Type",
    Url:"Url",
    Address:"Address",
    Address_Help:"Enter the address depending on the service, url (http:my.site.com), ip (8.8.8.8), host (my.host.net), server",
    MonitorInterval:"Monitoring interval",
    MonitorInterval_Help:"Monitoring interval in <b>seconds</b> (we recommend using at least 60 seconds)",
    RequestTimeout:"Timeout for the request",
    RequestTimeout_Help:"Time-out time in <b>seconds</b> for the request. The shorter the timeout, the sooner the service will be reported as down",
    SlowResponseTimeAlert:"Alert time for response",
    SlowResponseTimeAlert_Help:"Receive an alert if the response time is less than the set (in <b>milliseconds</b>). When it returns to a higher value, you receive a notification and the alert is closed.",
    MaintenanceWindows:"Maintenance window",
    MaintenanceWindows_Help:"Maintenance windows within which no checks are performed. e.g. 14:00:30-15:55:45, 21:00-23:00",
    HttpVerb:"Http Verb",
    HttpVerb_Help:"Method to use to make the http call (HEAD, GET, POST, PUT, PATCH, DELETE, OPTIONS, TRACE)",
    CompareType:"Body Result Comparison Mode",
    CompareType_Help:"How to compare the contents of the Answer Body with the <b>Result Success</b> field",
    SuccessResult:"Successful result",
    SuccessResult_Help:"Text used for comparison with Body content using Body <b>Result Comparison Mode</b>",
    rstaDetails:"Details",
    rstaNoElementSelectedSubTitle:"No items selected",
    editToolbarItem:"Modification",
    newToolbarItem:"New",
    deleteToolbarItem:"Delete",
    deleteConfirmMessage:"Are you sure you want to delete the element? The operation is irreversible",
    rstuiUsername:"Username",
    rstuiForgotPassword:"Forgot your password?",
    rstuiWrongPasswordMsg:"Incorrect username or password!",
    rstuiCancel:"Cancel",
    rstuiAll:"Everybody",
    rstuiFilters:"Standard Filters",
    rstuiSchede:"Tabs",
    rstuiSearch:"Research",
    rstuiList:"List",
    rstuiTable:"Table",
    rstuiValidatorRequiredField:"Required field",
    rstuiValidatorMinValue:"Lower value than minimum value",
    rstuiValidatorMaxValue:"Value higher than maximum value"
    };
    public static rst_resources_fr = {
    AgentId:"Agent",
    DeviceName:"Nom de l’appareil",
    FileName:"Nom du fichier",
    RstTagList:"Liste des tags",
    RstFolderID:"Fiche d’information",
    CompanyName:"Société",
    Name:"Nom",
    Surname:"Nom de famille",
    AgentToken:"Jetons",
    Agent_DeviceName:"Nom de l’appareil",
    Agent_IsEnabled:"Agent activé",
    LastRunningDate:"Dernière course",
    Agent_IsRunning:"Agent actif",
    DeviceArchitectureFamily:"Architecture",
    Agent_CompanyName:"Client",
    CurrentAgentVersion:"Version de l’agent",
    JobName:"Nom du poste",
    CurrentStatusText:"Situation actuelle",
    CategoryNameText:"Catégorie de poste",
    FirstExecutionDate:"Date de début",
    EndExecutionDate:"Date de fin",
    NextRunTriggerDate:"Prochaine date",
    LastRunExitCode:"Dernier code",
    LastRunDateTime:"Dernière date",
    IsJobEnabled:"Poste activé",
    CurrentStatus:"Statut",
    CategoryName:"Catégorie",
    Created:"Création",
    Modified:"Modifié",
    JobRunningLog:"Journal d’exécution des tâches",
    JobChartLog:"Journal des diagrammes de tâches",
    JobScheduler:"Planificateur de tâches",
    JobScheduler_IsJobEnabled:"Poste activé",
    agentNew:"Nouveau",
    agent:"Agent",
    agentConfigReset:"Réinitialiser la configuration de l’agent",
    agentInstantSendHardwareLogs:"Journaux matériels instantanés",
    agentSendCliCommand:"Exécution de la commande CLI (SignalR)",
    TriggerType:"Mode de déclenchement",
    h_TriggerType:"Comment le travail est exécuté :<br/> <b>Un temps :</b> une fois à l’heure indiquée<br/> <b>Minutely5 :</b> toutes les 5 minutes à partir de l’heure indiquée<br/> <b>Hourly :</b> chaque jour à partir de l’heure indiquée",
    CliCommand:"Commande de courir",
    h_CliCommand:"Nom de la commande à exécuter (sans arguments) par exemple <br/><br/>apt ls<br/>mkdir",
    CliArgs:"Arguments de commandement",
    h_CliArgs:"Spécifiez un argument par ligne, les espaces ne sont pas considérés comme des séparateurs d’arguments !",
    h_Job_FileName:"Le nom du fichier à exécuter sur l’agent, le fichier est tiré du dossier agent, ici indique simplement le nom du fichier.",
    LastRunResultErr:"Dernier message d’erreur",
    StandErr:"Message d’erreur",
    LastRunResultOut:"Dernier message",
    CustomerId:"Client",
    Subject:"Objet",
    Description:"Description de l’article",
    Description_Help:"Description",
    TicketHelpDescription:"Entrez la description détaillée du ticket, pour que <b>tous les</b> collaborateurs comprennent le problème.",
    Priority:"Priorité",
    PriorityText:"Priorité",
    PriorityTextHelp:"Indiquez la priorité du ticket lorsqu’elle est élevée, vous êtes notifié par une alerte",
    Patch_RebootRequired:"Redémarrage requis",
    Patch_Classification:"Classification",
    Patch_ScheduleTime:"Temps d’installation",
    Patch_PatchName:"Nom de l’écusson",
    Patch_OsType:"Plateforme OS",
    Patch_VersionToInstall:"Version à installer",
    Patch_VersionInstalled:"Version installée",
    Patch_Size:"Dimension",
    Patch_DeviceName:"Nom de l’appareil",
    Patch_WorkflowHistory:"Historique des flux de travail",
    Patch_Description:"Description",
    Software_IsEnabled:"Logiciel activé",
    Porta:"Port",
    ProtocolTypeText:"Type de protocole",
    CompareTypeText:"Type de comparaison",
    RequestHeaders:"En-tête de requête",
    RequestHeaders_Help:"Textes clés-valeur pour l’en-tête de la requête",
    RequestBody:"Corps de la demande",
    RequestBody_Help:"Texte ou json à envoyer dans le corps de la demande. <br/> application/x-www-form-urlencoded : field1=value1&amp;field2=value2 <br/> application/json : { my json... } <br/> raw text : my free text",
    SendMessage:"Message à envoyer",
    HttpContentType:"Type de soumission de données http",
    SendBodyAsJson:"Envoyez le corps en json (application/json) ou en texte (application/x-www-form-urlencoded)",
    SendBodyAsJson_Help:"Texte ou json à envoyer dans le corps de la demande",
    UpHttpStatusCodes:"Codes d’état HTTP valides",
    UpHttpStatusCodes_Help:"Une alerte est créée lorsqu’un code d’état HTTP autre que le suivant (200 302 ou 2xx, 3xx) est reçu",
    FilterMatchMonitorStatus:"Changer de statut si le filtre correspond",
    FilterMatchMonitorStatus_Help:"Si les critères du filtre correspondent, le statut de surveillance actuel est défini",
    CurrentMonitorStatus:"Statut actuel de la surveillance",
    CurrentMonitorStatus_Help:"État de surveillance du protocole (hors ligne, dégradé, opérationnel, maintenance)",
    FilterMatchCreateAlert:"Lorsque des filtres s’exécutent, il crée des alertes",
    FilterMatchCreateAlert_Help:"Si les filtres configurés ci-dessus correspondent (retournent une condition vraie), une alerte est créée avec les données sous-jacentes",
    FilterMatchStrategy:"Condition de correspondance du filtre",
    FilterMatchStrategy_Help:"Vous sélectionnez si tous les filtres doivent correspondre, ou s’il suffit d’en correspondre au moins un",
    AlertName:"Nom d’alerte",
    AlertSeverity:"Sévérité de l’alerte",
    AutoResolveAlert:"Résolution automatique des alertes",
    AutoResolveAlert_Help:"Si les filtres ne correspondent plus, l’alerte est automatiquement résolue",
    ProtocolName:"Nom",
    ProtocolType:"Type de protocole",
    Url:"URL",
    Address:"Adresse",
    Address_Help:"Saisissez l’adresse en fonction du service, de l’URL (http:my.site.com), de l’IP (8.8.8.8), de l’hôte (my.host.net), du serveur",
    MonitorInterval:"Intervalle de surveillance",
    MonitorInterval_Help:"Intervalle de surveillance en <b>secondes</b> (nous recommandons d’utiliser au moins 60 secondes)",
    RequestTimeout:"Temps mort pour la demande",
    RequestTimeout_Help:"Temps d’attente en <b>secondes</b> pour la demande. Plus le délai d’arrêt est court, plus vite le service sera signalé comme inactif",
    SlowResponseTimeAlert:"Temps d’alerte pour la réponse",
    SlowResponseTimeAlert_Help:"Recevoir une alerte si le temps de réponse est inférieur à celui défini (en <b>millisecondes</b>). Lorsqu’elle revient à une valeur supérieure, vous recevez une notification et l’alerte est fermée.",
    MaintenanceWindows:"Fenêtre de maintenance",
    MaintenanceWindows_Help:"Fenêtres de maintenance durant lesquelles aucune vérification n’est effectuée. par exemple 14:00:30-15:55:45, 21:00-23:00",
    HttpVerb:"Verbe Http",
    HttpVerb_Help:"Méthode à utiliser pour effectuer l’appel http (HEAD, GET, POST, PUT, PATCH, DELETE, OPTIONS, TRACE)",
    CompareType:"Mode de comparaison des résultats corporels",
    CompareType_Help:"Comment comparer le contenu du corps de la réponse avec le champ <b>Succès du</b> résultat",
    SuccessResult:"Résultat réussi",
    SuccessResult_Help:"Texte utilisé pour la comparaison avec le contenu du corps en <b>utilisant le mode de comparaison des résultats</b> du corps",
    rstaDetails:"Les tenants et aboutissants",
    rstaNoElementSelectedSubTitle:"Aucun article sélectionné",
    editToolbarItem:"Modification",
    newToolbarItem:"Nouveau",
    deleteToolbarItem:"Supprimer",
    deleteConfirmMessage:"Êtes-vous sûr de vouloir supprimer l’élément ? L’opération est irréversible",
    rstuiUsername:"Nom d’utilisateur",
    rstuiForgotPassword:"Vous avez oublié votre mot de passe ?",
    rstuiWrongPasswordMsg:"Nom d’utilisateur ou mot de passe incorrect !",
    rstuiCancel:"Annuler",
    rstuiAll:"Tout le monde",
    rstuiFilters:"Filtres standard",
    rstuiSchede:"Onglets",
    rstuiSearch:"Recherche",
    rstuiList:"Liste",
    rstuiTable:"Table",
    rstuiValidatorRequiredField:"Champ obligatoire",
    rstuiValidatorMinValue:"Valeur inférieure à la valeur minimale",
    rstuiValidatorMaxValue:"Valeur supérieure à la valeur maximale"
    };
    public static rst_resources_de = {
    AgentId:"Agent",
    DeviceName:"Gerätename",
    FileName:"Dateiname",
    RstTagList:"Tag-Liste",
    RstFolderID:"Informationsblatt",
    CompanyName:"Gesellschaft",
    Name:"Name",
    Surname:"Nachname",
    AgentToken:"Tokens",
    Agent_DeviceName:"Gerätename",
    Agent_IsEnabled:"Agent aktiviert",
    LastRunningDate:"Letzter Lauf",
    Agent_IsRunning:"Wirkstoff",
    DeviceArchitectureFamily:"Architektur",
    Agent_CompanyName:"Kunde",
    CurrentAgentVersion:"Agent-Version",
    JobName:"Name der Stelle",
    CurrentStatusText:"Aktueller Stand",
    CategoryNameText:"Berufskategorie",
    FirstExecutionDate:"Startdatum",
    EndExecutionDate:"Enddatum",
    NextRunTriggerDate:"Nächster Termin",
    LastRunExitCode:"Neuester Code",
    LastRunDateTime:"Letztes Datum",
    IsJobEnabled:"Job ermöglicht",
    CurrentStatus:"Status",
    CategoryName:"Kategorie",
    Created:"Kreation",
    Modified:"Umgeändert",
    JobRunningLog:"Protokoll zum Ausführen des Auftrags",
    JobChartLog:"Job-Chart-Protokoll",
    JobScheduler:"Job-Planer",
    JobScheduler_IsJobEnabled:"Job ermöglicht",
    agentNew:"Neu",
    agent:"Agent",
    agentConfigReset:"Agentenkonfiguration zurücksetzen",
    agentInstantSendHardwareLogs:"Sofortige Hardware-Protokolle",
    agentSendCliCommand:"Ausführen des CLI-Befehls (SignalR)",
    TriggerType:"Trigger-Modus",
    h_TriggerType:"Wie die Aufgabe ausgeführt wird:<br/> <b>OneTime:</b> einmal zur angegebenen<br/> Zeit<b>Minutengenau5:</b> alle 5 Minuten ab dem angegebenen<br/> Zeitpunkt<b>Stundenweise:</b> jeden Tag ab der angegebenen Zeit",
    CliCommand:"Befehl zum Ausführen",
    h_CliCommand:"Name des zu ausführenden Befehls (ohne Argumente), z. B. <br/><br/>Apt LS<br/>Mkdir",
    CliArgs:"Befehlsargumente",
    h_CliArgs:"Geben Sie pro Zeile ein Argument an, Leerzeichen werden nicht als Argumenttrenner betrachtet!",
    h_Job_FileName:"Der Name der Datei, die auf dem Agenten ausgeführt werden soll, stammt aus dem Agentenordner, hier gibt man einfach den Namen der Datei an.",
    LastRunResultErr:"Letzte Fehlermeldung",
    StandErr:"Fehlermeldung",
    LastRunResultOut:"Letzter Beitrag",
    CustomerId:"Kunde",
    Subject:"Objekt",
    Description:"Artikelbeschreibung",
    Description_Help:"Beschreibung",
    TicketHelpDescription:"Geben Sie die detaillierte Beschreibung des Tickets ein, damit <b>alle</b> Mitarbeiter das Problem verstehen.",
    Priority:"Priorität",
    PriorityText:"Priorität",
    PriorityTextHelp:"Geben Sie die Priorität des Tickets an, wenn sie hoch ist, Sie werden mit einer Benachrichtigung benachrichtigt",
    Patch_RebootRequired:"Neustart erforderlich",
    Patch_Classification:"Klassifikation",
    Patch_ScheduleTime:"Installationszeit",
    Patch_PatchName:"Name des Patches",
    Patch_OsType:"OS-Plattform",
    Patch_VersionToInstall:"Version zur Installation",
    Patch_VersionInstalled:"Installierte Version",
    Patch_Size:"Dimension",
    Patch_DeviceName:"Gerätename",
    Patch_WorkflowHistory:"Workflow-Geschichte",
    Patch_Description:"Beschreibung",
    Software_IsEnabled:"Softwareaktiviert",
    Porta:"Hafen",
    ProtocolTypeText:"Protokolltyp",
    CompareTypeText:"Vergleichstyp",
    RequestHeaders:"Anfrage-Header",
    RequestHeaders_Help:"Schlüssel-Wert-Texte für den Header der Anfrage",
    RequestBody:"Hauptteil der Anfrage",
    RequestBody_Help:"Text oder JSON soll im Hauptteil der Anfrage gesendet werden. <br/> application/x-www-form-urlencoded: field1=value1&amp;field2=value2 <br/> application/json: { mein json... } <br/> roher Text: mein Freitext",
    SendMessage:"Nachricht zu senden",
    HttpContentType:"Art der HTTP-Dateneinreichung",
    SendBodyAsJson:"Senden Sie den Text als JSON (application/json) oder als Text (application/x-www-form-urlencoded)",
    SendBodyAsJson_Help:"Text oder JSON soll im Hauptteil der Anfrage gesendet werden",
    UpHttpStatusCodes:"Gültige HTTP-Statuscodes",
    UpHttpStatusCodes_Help:"Eine Warnung wird erstellt, wenn ein anderer HTTP-Statuscode als der folgende (200,302 oder 2xx, 3xx) empfangen wird",
    FilterMatchMonitorStatus:"Status ändern, wenn der Filter übereinstimmt",
    FilterMatchMonitorStatus_Help:"Wenn die Filterkriterien übereinstimmen, wird der aktuelle Überwachungsstatus festgelegt",
    CurrentMonitorStatus:"Aktueller Überwachungsstatus",
    CurrentMonitorStatus_Help:"Protokollüberwachungsstatus (Offline, Verschlechtert, Betriebsfähig, Wartung)",
    FilterMatchCreateAlert:"Wenn Filter laufen, werden Warnungen erzeugt",
    FilterMatchCreateAlert_Help:"Wenn die oben gesetzten Filter übereinstimmen (eine wahre Bedingung zurückgeben), wird eine Warnung mit den zugrunde liegenden Daten erstellt",
    FilterMatchStrategy:"Filter-Match-Bedingung",
    FilterMatchStrategy_Help:"Du wählst, ob alle Filter übereinstimmen sollen oder ob es nur mindestens einen Filter geben muss",
    AlertName:"Alarmname",
    AlertSeverity:"Warnschweregrad",
    AutoResolveAlert:"Automatisch lösen Sie Warnungen auf",
    AutoResolveAlert_Help:"Wenn die Filter nicht mehr übereinstimmen, wird die Warnung automatisch gelöst",
    ProtocolName:"Name",
    ProtocolType:"Protokolltyp",
    Url:"URL",
    Address:"Adresse",
    Address_Help:"Geben Sie die Adresse je nach Dienst ein: URL (http:my.site.com), IP (8.8.8.8), Host (my.host.net), Server",
    MonitorInterval:"Überwachungsintervall",
    MonitorInterval_Help:"Überwachungsintervall in <b>Sekunden</b> (wir empfehlen mindestens 60 Sekunden)",
    RequestTimeout:"Auszeit für die Anfrage",
    RequestTimeout_Help:"Auszeit in <b>Sekunden</b> für die Anfrage. Je kürzer die Auszeit, desto eher wird der Dienst als ausgefallen gemeldet",
    SlowResponseTimeAlert:"Alarmzeit für die Reaktion",
    SlowResponseTimeAlert_Help:"Erhalten Sie eine Warnung, wenn die Antwortzeit kürzer als die eingestellte Laufzeit (in <b>Millisekunden</b>) ist. Wenn der Wert wieder höher wird, erhalten Sie eine Benachrichtigung und die Benachrichtigung wird geschlossen.",
    MaintenanceWindows:"Wartungsfenster",
    MaintenanceWindows_Help:"Wartungsfenster, innerhalb derer keine Überprüfungen durchgeführt werden. z. B. 14:00:30-15:55:45, 21:00-23:00",
    HttpVerb:"Http-Verb",
    HttpVerb_Help:"Methode, mit der der HTTP-Aufruf verwendet wird (HEAD, GET, POST, PUT, PATCH, DELETE, OPTIONS, TRACE)",
    CompareType:"Vergleichsmodus für Karosserieergebnisse",
    CompareType_Help:"Wie man den Inhalt des Antwortkörpers mit dem <b>Ergebnis-Erfolgsfeld</b> vergleicht",
    SuccessResult:"Erfolgreiches Ergebnis",
    SuccessResult_Help:"Text, der zum Vergleich mit dem Haupttext im Body <b>Result Comparison Mode</b> verwendet wird",
    rstaDetails:"Vor- und Nachteile",
    rstaNoElementSelectedSubTitle:"Keine Artikel ausgewählt",
    editToolbarItem:"Modifikation",
    newToolbarItem:"Neu",
    deleteToolbarItem:"Löschen",
    deleteConfirmMessage:"Bist du sicher, dass du das Element löschen willst? Die Operation ist irreversibel",
    rstuiUsername:"Nutzername",
    rstuiForgotPassword:"Passwort vergessen?",
    rstuiWrongPasswordMsg:"Falscher Benutzername oder falsches Passwort!",
    rstuiCancel:"Abbrechen",
    rstuiAll:"Jeder",
    rstuiFilters:"Standard-Filter",
    rstuiSchede:"Tabulatoren",
    rstuiSearch:"Forschung",
    rstuiList:"Liste",
    rstuiTable:"Tisch",
    rstuiValidatorRequiredField:"Pflichtfeld",
    rstuiValidatorMinValue:"Unterer Wert als der Minimalwert",
    rstuiValidatorMaxValue:"Wert höher als der Maximalwert"
    };
    
public static Copy_rst_resources(src) {
  if (src == null)
      return;
                    rst_resources.AgentId = src.AgentId;
                    rst_resources.DeviceName = src.DeviceName;
                    rst_resources.FileName = src.FileName;
                    rst_resources.RstTagList = src.RstTagList;
                    rst_resources.RstFolderID = src.RstFolderID;
                    rst_resources.CompanyName = src.CompanyName;
                    rst_resources.Name = src.Name;
                    rst_resources.Surname = src.Surname;
                    rst_resources.AgentToken = src.AgentToken;
                    rst_resources.Agent_DeviceName = src.Agent_DeviceName;
                    rst_resources.Agent_IsEnabled = src.Agent_IsEnabled;
                    rst_resources.LastRunningDate = src.LastRunningDate;
                    rst_resources.Agent_IsRunning = src.Agent_IsRunning;
                    rst_resources.DeviceArchitectureFamily = src.DeviceArchitectureFamily;
                    rst_resources.Agent_CompanyName = src.Agent_CompanyName;
                    rst_resources.CurrentAgentVersion = src.CurrentAgentVersion;
                    rst_resources.JobName = src.JobName;
                    rst_resources.CurrentStatusText = src.CurrentStatusText;
                    rst_resources.CategoryNameText = src.CategoryNameText;
                    rst_resources.FirstExecutionDate = src.FirstExecutionDate;
                    rst_resources.EndExecutionDate = src.EndExecutionDate;
                    rst_resources.NextRunTriggerDate = src.NextRunTriggerDate;
                    rst_resources.LastRunExitCode = src.LastRunExitCode;
                    rst_resources.LastRunDateTime = src.LastRunDateTime;
                    rst_resources.IsJobEnabled = src.IsJobEnabled;
                    rst_resources.CurrentStatus = src.CurrentStatus;
                    rst_resources.CategoryName = src.CategoryName;
                    rst_resources.Created = src.Created;
                    rst_resources.Modified = src.Modified;
                    rst_resources.JobRunningLog = src.JobRunningLog;
                    rst_resources.JobChartLog = src.JobChartLog;
                    rst_resources.JobScheduler = src.JobScheduler;
                    rst_resources.JobScheduler_IsJobEnabled = src.JobScheduler_IsJobEnabled;
                    rst_resources.agentNew = src.agentNew;
                    rst_resources.agent = src.agent;
                    rst_resources.agentConfigReset = src.agentConfigReset;
                    rst_resources.agentInstantSendHardwareLogs = src.agentInstantSendHardwareLogs;
                    rst_resources.agentSendCliCommand = src.agentSendCliCommand;
                    rst_resources.TriggerType = src.TriggerType;
                    rst_resources.h_TriggerType = src.h_TriggerType;
                    rst_resources.CliCommand = src.CliCommand;
                    rst_resources.h_CliCommand = src.h_CliCommand;
                    rst_resources.CliArgs = src.CliArgs;
                    rst_resources.h_CliArgs = src.h_CliArgs;
                    rst_resources.h_Job_FileName = src.h_Job_FileName;
                    rst_resources.LastRunResultErr = src.LastRunResultErr;
                    rst_resources.StandErr = src.StandErr;
                    rst_resources.LastRunResultOut = src.LastRunResultOut;
                    rst_resources.CustomerId = src.CustomerId;
                    rst_resources.Subject = src.Subject;
                    rst_resources.Description = src.Description;
                    rst_resources.Description_Help = src.Description_Help;
                    rst_resources.TicketHelpDescription = src.TicketHelpDescription;
                    rst_resources.Priority = src.Priority;
                    rst_resources.PriorityText = src.PriorityText;
                    rst_resources.PriorityTextHelp = src.PriorityTextHelp;
                    rst_resources.Patch_RebootRequired = src.Patch_RebootRequired;
                    rst_resources.Patch_Classification = src.Patch_Classification;
                    rst_resources.Patch_ScheduleTime = src.Patch_ScheduleTime;
                    rst_resources.Patch_PatchName = src.Patch_PatchName;
                    rst_resources.Patch_OsType = src.Patch_OsType;
                    rst_resources.Patch_VersionToInstall = src.Patch_VersionToInstall;
                    rst_resources.Patch_VersionInstalled = src.Patch_VersionInstalled;
                    rst_resources.Patch_Size = src.Patch_Size;
                    rst_resources.Patch_DeviceName = src.Patch_DeviceName;
                    rst_resources.Patch_WorkflowHistory = src.Patch_WorkflowHistory;
                    rst_resources.Patch_Description = src.Patch_Description;
                    rst_resources.Software_IsEnabled = src.Software_IsEnabled;
                    rst_resources.Porta = src.Porta;
                    rst_resources.ProtocolTypeText = src.ProtocolTypeText;
                    rst_resources.CompareTypeText = src.CompareTypeText;
                    rst_resources.RequestHeaders = src.RequestHeaders;
                    rst_resources.RequestHeaders_Help = src.RequestHeaders_Help;
                    rst_resources.RequestBody = src.RequestBody;
                    rst_resources.RequestBody_Help = src.RequestBody_Help;
                    rst_resources.SendMessage = src.SendMessage;
                    rst_resources.HttpContentType = src.HttpContentType;
                    rst_resources.SendBodyAsJson = src.SendBodyAsJson;
                    rst_resources.SendBodyAsJson_Help = src.SendBodyAsJson_Help;
                    rst_resources.UpHttpStatusCodes = src.UpHttpStatusCodes;
                    rst_resources.UpHttpStatusCodes_Help = src.UpHttpStatusCodes_Help;
                    rst_resources.FilterMatchMonitorStatus = src.FilterMatchMonitorStatus;
                    rst_resources.FilterMatchMonitorStatus_Help = src.FilterMatchMonitorStatus_Help;
                    rst_resources.CurrentMonitorStatus = src.CurrentMonitorStatus;
                    rst_resources.CurrentMonitorStatus_Help = src.CurrentMonitorStatus_Help;
                    rst_resources.FilterMatchCreateAlert = src.FilterMatchCreateAlert;
                    rst_resources.FilterMatchCreateAlert_Help = src.FilterMatchCreateAlert_Help;
                    rst_resources.FilterMatchStrategy = src.FilterMatchStrategy;
                    rst_resources.FilterMatchStrategy_Help = src.FilterMatchStrategy_Help;
                    rst_resources.AlertName = src.AlertName;
                    rst_resources.AlertSeverity = src.AlertSeverity;
                    rst_resources.AutoResolveAlert = src.AutoResolveAlert;
                    rst_resources.AutoResolveAlert_Help = src.AutoResolveAlert_Help;
                    rst_resources.ProtocolName = src.ProtocolName;
                    rst_resources.ProtocolType = src.ProtocolType;
                    rst_resources.Url = src.Url;
                    rst_resources.Address = src.Address;
                    rst_resources.Address_Help = src.Address_Help;
                    rst_resources.MonitorInterval = src.MonitorInterval;
                    rst_resources.MonitorInterval_Help = src.MonitorInterval_Help;
                    rst_resources.RequestTimeout = src.RequestTimeout;
                    rst_resources.RequestTimeout_Help = src.RequestTimeout_Help;
                    rst_resources.SlowResponseTimeAlert = src.SlowResponseTimeAlert;
                    rst_resources.SlowResponseTimeAlert_Help = src.SlowResponseTimeAlert_Help;
                    rst_resources.MaintenanceWindows = src.MaintenanceWindows;
                    rst_resources.MaintenanceWindows_Help = src.MaintenanceWindows_Help;
                    rst_resources.HttpVerb = src.HttpVerb;
                    rst_resources.HttpVerb_Help = src.HttpVerb_Help;
                    rst_resources.CompareType = src.CompareType;
                    rst_resources.CompareType_Help = src.CompareType_Help;
                    rst_resources.SuccessResult = src.SuccessResult;
                    rst_resources.SuccessResult_Help = src.SuccessResult_Help;
                    rst_resources.rstaDetails = src.rstaDetails;
                    rst_resources.rstaNoElementSelectedSubTitle = src.rstaNoElementSelectedSubTitle;
                    rst_resources.editToolbarItem = src.editToolbarItem;
                    rst_resources.newToolbarItem = src.newToolbarItem;
                    rst_resources.deleteToolbarItem = src.deleteToolbarItem;
                    rst_resources.deleteConfirmMessage = src.deleteConfirmMessage;
                    rst_resources.rstuiUsername = src.rstuiUsername;
                    rst_resources.rstuiForgotPassword = src.rstuiForgotPassword;
                    rst_resources.rstuiWrongPasswordMsg = src.rstuiWrongPasswordMsg;
                    rst_resources.rstuiCancel = src.rstuiCancel;
                    rst_resources.rstuiAll = src.rstuiAll;
                    rst_resources.rstuiFilters = src.rstuiFilters;
                    rst_resources.rstuiSchede = src.rstuiSchede;
                    rst_resources.rstuiSearch = src.rstuiSearch;
                    rst_resources.rstuiList = src.rstuiList;
                    rst_resources.rstuiTable = src.rstuiTable;
                    rst_resources.rstuiValidatorRequiredField = src.rstuiValidatorRequiredField;
                    rst_resources.rstuiValidatorMinValue = src.rstuiValidatorMinValue;
                    rst_resources.rstuiValidatorMaxValue = src.rstuiValidatorMaxValue;
                };
                }